import { RebuildNotice } from '@/components/RebuildNotice'
export default function Page() { return <RebuildNotice title="System health" hint="Service uptime, DB pool, last-deploy." /> }
